import { ApprovalStatus } from '@/types/Approval';
import ms from 'ms';

export const BID_LIMIT_SLICE_CACHE_TIME = ms('1s');

type BidLimit = {
    balance: number;
};

export type BidLimitSlice = {
    byId: { [catalogId: number]: BidLimit };
    loaded: { [catalogId: number]: number };
    loading: number[];
};

export const defaultBidLimitSlice: BidLimitSlice = {
    byId: {},
    loaded: {},
    loading: [],
};

export type FetchBidLimitParams = {
    catalogId: number;
    force?: boolean;
    itemId?: number;
};

export type BidLimitBalance = {
    approvalStatus: ApprovalStatus;
    bidLimit: number;
    bidLimitRemaining: number;
    bidderId: number;
    catalogId: number;
};

export type getBidLimitBalanceParams = {
    authToken: string;
    bidderId: number;
    catalogId: number;
    deployment: string;
    itemId?: number;
};

export type getBidLimitBalanceResponse = {
    error: boolean;
    payload: BidLimitBalance;
};
